import { render, staticRenderFns } from "./DisableServiceDescDialog.vue?vue&type=template&id=e5cbe648&scoped=true&"
import script from "./DisableServiceDescDialog.vue?vue&type=script&lang=ts&"
export * from "./DisableServiceDescDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DisableServiceDescDialog.vue?vue&type=style&index=0&id=e5cbe648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cbe648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
